module.exports = __webpack_public_path__ + "static/Cobol-f706142a318e515251f5644be4b39749.svg";